import {all, call, fork, put, takeEvery} from "redux-saga/effects";
import {getAdvertisements} from "apollo/queries/getAdvertisements";
import {getCoupons} from "apollo/queries/getCoupons";
import {getVotings} from "apollo/queries/getVotings";
import {getPollings} from "apollo/queries/getPollings";
import {getAdvertisement} from "apollo/queries/getAdvertisement";
import {getCoupon} from "apollo/queries/getCoupon";
import {getVoting} from "apollo/queries/getVoting";
import {getPolling} from "apollo/queries/getPolling";
import {getEvents} from "apollo/queries/getEvents";
import {getDeepLinks} from "apollo/queries/getDeepLinks";
import {getDeepLink} from "apollo/queries/getDeepLink";
import {getPollingQuestionsWithAnswers} from "apollo/queries/getPollingQuestionsWithAnswers";
import {getVotingQuestionsWithAnswers} from "apollo/queries/getVotingQuestionsWithAnswers";
import {getPollingAnswers} from "apollo/queries/getPollingAnswers";
import {getVotingAnswers} from "apollo/queries/getVotingAnswers";
import {fetchError} from "../actions/Common";
import {createEventMutation} from "apollo/mutations/createEvent";
import {updateEventMutation} from "apollo/mutations/updateEvent";
import {deleteEventMutation} from "apollo/mutations/deleteEvent";
import {createAdvertisementMutation} from "apollo/mutations/createAdvertisement";
import {updateAdvertisementMutation} from "apollo/mutations/updateAdvertisement";
import {deleteAdvertisementMutation} from "apollo/mutations/deleteAdvertisement";
import {createCouponMutation} from "apollo/mutations/createCoupon";
import {updateCouponMutation} from "apollo/mutations/updateCoupon";
import {deleteCouponMutation} from "apollo/mutations/deleteCoupon";
import {createVotingMutation} from "apollo/mutations/createVoting";
import {updateVotingMutation} from "apollo/mutations/updateVoting";
import {deleteVotingMutation} from "apollo/mutations/deleteVoting";
import {createPollingMutation} from "apollo/mutations/createPolling";
import {updatePollingMutation} from "apollo/mutations/updatePolling";
import {deletePollingMutation} from "apollo/mutations/deletePolling";
import {createDeepLinkMutation} from "apollo/mutations/createDeepLink";
import {updateDeepLinkMutation} from "apollo/mutations/updateDeepLink";
import {deleteDeepLinkMutation} from "apollo/mutations/deleteDeepLink";

import {fetchAdvertisementsSuccess, fetchCouponsSuccess,
fetchVotingsSuccess, fetchPollingsSuccess, fetchDeepLinksSuccess,
fetchAdvertisementSuccess, fetchCouponSuccess,
fetchVotingSuccess, fetchPollingSuccess, fetchDeepLinkSuccess,
fetchEventsSuccess, createEventSuccess, updateEventSuccess, deleteEventSuccess,
fetchVotingQuestionsSuccess, fetchPollingQuestionsSuccess,
fetchVotingAnswersSuccess, fetchPollingAnswersSuccess,
createAdvertisementSuccess, updateAdvertisementSuccess, deleteAdvertisementSuccess,
createCouponSuccess, updateCouponSuccess, deleteCouponSuccess,
createVotingSuccess, updateVotingSuccess, deleteVotingSuccess,
createPollingSuccess, updatePollingSuccess, deletePollingSuccess,
createDeepLinkSuccess, updateDeepLinkSuccess, deleteDeepLinkSuccess} from "../actions/Minisite";
import {client} from "apollo/client";

import {
  FETCHADVERTISEMENTS,
  FETCHCOUPONS,
  FETCHVOTINGS,
  FETCHPOLLINGS,
  FETCHDEEPLINKS,
  FETCHADVERTISEMENT,
  FETCHCOUPON,
  FETCHVOTING,
  FETCHPOLLING,
  FETCHDEEPLINK,
  FETCHEVENTS,
  CREATEEVENT,
  UPDATEEVENT,
  DELETEEVENT,
  FETCHVOTINGQUESTIONS,
  FETCHPOLLINGQUESTIONS,
  FETCHVOTINGANSWERS,
  FETCHPOLLINGANSWERS,
  CREATEADVERTISEMENT,
  UPDATEADVERTISEMENT,
  DELETEADVERTISEMENT,
  CREATECOUPON,
  UPDATECOUPON,
  DELETECOUPON,
  CREATEVOTING,
  UPDATEVOTING,
  DELETEVOTING,
  CREATEPOLLING,
  UPDATEPOLLING,
  DELETEPOLLING,
  CREATEDEEPLINK,
  UPDATEDEEPLINK,
  DELETEDEEPLINK,
} from "constants/ActionTypes";

const fetchAdvertisementsRequest = async (applicationId) => {
  try {
    let { data, error } = await client.query({
      query: getAdvertisements,
      variables: {
        application: applicationId
      },
      fetchPolicy: 'network-only'
    });

    console.log('data', data);
    console.log('error', error);

    if (data) {
      return Promise.resolve(data);
    } else {
      console.log('fetchAdvertisementsRequest error', error);
      return Promise.reject(error);
    }
  } catch (e) {
    console.log('e', e);
    return Promise.reject(e);
  }
}

const fetchVotingQuestionsRequest = async (voting) => {
  try {
    let { data, error } = await client.query({
      query: getVotingQuestionsWithAnswers,
      variables: {
        voting: voting
      },
      fetchPolicy: 'network-only'
    });

    if (data) {
      return Promise.resolve(data, voting);
    } else {
      console.log('fetchAdvertisementsRequest error', error);
      return Promise.reject(error);
    }
  } catch (e) {
    console.log('e', e);
    return Promise.reject(e);
  }
}

const fetchPollingQuestionsRequest = async (polling) => {
  try {
    let { data, error } = await client.query({
      query: getPollingQuestionsWithAnswers,
      variables: {
        polling: polling
      },
      fetchPolicy: 'network-only'
    });

    if (data) {
      return Promise.resolve(data, polling);
    } else {
      return Promise.reject(error);
    }
  } catch (e) {
    console.log('e', e);
    return Promise.reject(e);
  }
}

const fetchPollingAnswersRequest = async (pollingQuestionId) => {
  try {
    let { data, error } = await client.query({
      query: getPollingAnswers,
      variables: {
        pollingQuestion: pollingQuestionId
      },
      fetchPolicy: 'network-only'
    });

    if (data) {
      return Promise.resolve(data, pollingQuestionId);
    } else {
      return Promise.reject(error);
    }
  } catch (e) {
    console.log('e', e);
    return Promise.reject(e);
  }
}

const fetchVotingAnswersRequest = async (votingQuestionId) => {
  try {
    let { data, error } = await client.query({
      query: getVotingAnswers,
      variables: {
        votingQuestion: votingQuestionId
      },
      fetchPolicy: 'network-only'
    });

    if (data) {
      return Promise.resolve(data, votingQuestionId);
    } else {
      return Promise.reject(error);
    }
  } catch (e) {
    console.log('e', e);
    return Promise.reject(e);
  }
}

const fetchCouponsRequest = async (applicationId) => {
  try {
    console.log('fetchCouponsRequest', applicationId);
    let { data, error } = await client.query({
      query: getCoupons,
      variables: {
        application: applicationId
      },
      fetchPolicy: 'network-only'
    });

    if (data) {
      console.log('fetchCouponsRequest', data);
      return Promise.resolve(data);
    } else {
      console.log('fetchCouponsRequest', applicationId);
      return Promise.reject(error);
    }
  } catch (e) {
    console.log('e', e);
    return Promise.reject(e);
  }
}

const fetchVotingsRequest = async (applicationId) => {
  let { data, error } = await client.query({
    query: getVotings,
    variables: {
      application: applicationId
    },
    fetchPolicy: 'network-only'
  });

  if (data) {
    return Promise.resolve(data);
  } else {
    return Promise.reject(error);
  }
}

const fetchPollingsRequest = async (applicationId) => {
  let { data, error } = await client.query({
    query: getPollings,
    variables: {
      application: applicationId,
    },
    fetchPolicy: 'network-only'
  });

  if (data) {
    return Promise.resolve(data);
  } else {
    return Promise.reject(error);
  }
}

const fetchDeepLinksRequest = async (applicationId) => {
  try {
    let { data, error } = await client.query({
      query: getDeepLinks,
      variables: {
        application: applicationId,
      },
      fetchPolicy: 'network-only'
    });

    console.log('data', data);
    console.log('error', error);

    if (data) {
      return Promise.resolve(data);
    } else {
      return Promise.reject(error);
    }
  } catch (e) {
    console.log('e', e);
    return Promise.reject(e);
  }
}

const fetchAdvertisementRequest = async (minisiteId) => {
  console.log('fetchAdvertisementRequest', minisiteId);

  try {
    let { data, error } = await client.query({
      query: getAdvertisement,
      variables: {
        minisiteId: minisiteId
      },
      fetchPolicy: 'network-only'
    });

    if (data) {
      return Promise.resolve(data);
    } else {
      console.log('fetchAdvertisementRequest error', error);
      return Promise.reject(error);
    }
  } catch (e) {
    console.log('e', e);
    return Promise.reject(e);
  }
}

const fetchCouponRequest = async (minisiteId) => {
  try {
    console.log('fetchCouponRequest', minisiteId);
    let { data, error } = await client.query({
      query: getCoupon,
      variables: {
        minisiteId: minisiteId
      },
      fetchPolicy: 'network-only'
    });

    if (data) {
      console.log('fetchCouponRequest', data);
      return Promise.resolve(data);
    } else {
      console.log('fetchCouponRequest', minisiteId);
      return Promise.reject(error);
    }
  } catch (e) {
    console.log('e', e);
    return Promise.reject(e);
  }
}

const fetchVotingRequest = async (minisiteId) => {
  try {
    let { data, error } = await client.query({
      query: getVoting,
      variables: {
        minisiteId: minisiteId
      },
      fetchPolicy: 'network-only'
    });

    console.log('data error', data, error);

    if (data) {
      return Promise.resolve(data);
    } else {
      return Promise.reject(error);
    }
  } catch (e) {
    return Promise.reject(e);
  }
}

const fetchPollingRequest = async (minisiteId) => {
  try {
    let { data, error } = await client.query({
      query: getPolling,
      variables: {
        minisiteId: minisiteId
      },
      fetchPolicy: 'network-only'
    });

    console.log('data error', data, error);

    if (data) {
      return Promise.resolve(data);
    } else {
      return Promise.reject(error);
    }
  } catch (e) {
    console.log(e);
    return Promise.reject(e);
  }
}

const fetchDeepLinkRequest = async (minisiteId) => {
  try {
    let { data, error } = await client.query({
      query: getDeepLink,
      variables: {
        minisiteId: minisiteId
      },
      fetchPolicy: 'network-only'
    });

    console.log('data error', data, error);

    if (data) {
      return Promise.resolve(data);
    } else {
      return Promise.reject(error);
    }
  } catch (e) {
    console.log(e);
    return Promise.reject(e);
  }
}

const fetchEventsRequest = async (minisiteId) => {
  console.log('fetchEventsRequest', minisiteId);
  try {
    let { data, error } = await client.query({
      query: getEvents,
      variables: {
        minisite: minisiteId,
      },
      fetchPolicy: 'network-only'
    });

    console.log('data', data, error);

    if (data) {
      return Promise.resolve(data);
    } else {
      return Promise.reject(error);
    }
  } catch (e) {
    console.log('e', e);
    return Promise.reject(e);
  }
}

const createEventRequest = async (input) => {
  try {
    let { data, error } = await client.mutate({
      mutation: createEventMutation,
      variables: {
        input: input
      }
    });

    console.log('data', data);
    console.log('error', error);

    if (data) {
      return Promise.resolve(data);
    } else {
      return Promise.reject(error);
    }
  } catch (e) {
    console.log('e', e);
    return Promise.reject(e);
  }
}

const updateEventRequest = async (input) => {

  console.log('input', input);

  try {
    let { data, error } = await client.mutate({
      mutation: updateEventMutation,
      variables: {
        input: input
      }
    });

    console.log('data', data);
    console.log('error', error);

    if (data) {
      return Promise.resolve(data);
    } else {
      return Promise.reject(error);
    }
  } catch (e) {
    console.log('e', e);
    return Promise.reject(e);
  }
}

const deleteEventRequest = async (input) => {
  console.log('input', input);

  try {
    let { data, error } = await client.mutate({
      mutation: deleteEventMutation,
      variables: {
        deviceId: input.deviceId
      }
    });

    console.log('data', data);

    if (data.deleteEventById.rows_deleted > 0) {
      return Promise.resolve(data);
    } else {
      return Promise.reject("Device not found");
    }
  } catch (e) {
    console.log('e', e);
    return Promise.reject(e);
  }
}

const createAdvertisementRequest = async (input) => {
  try {
    let { data, error } = await client.mutate({
      mutation: createAdvertisementMutation,
      variables: {
        input: input
      }
    });

    console.log('data', data);
    console.log('error', error);

    if (data) {
      return Promise.resolve(data);
    } else {
      return Promise.reject(error);
    }
  } catch (e) {
    console.log('e', e);
    return Promise.reject(e);
  }
}

const updateAdvertisementRequest = async (input) => {

  console.log('input', input);

  try {
    let { data, error } = await client.mutate({
      mutation: updateAdvertisementMutation,
      variables: {
        input: input
      }
    });

    console.log('data', data);
    console.log('error', error);

    if (data) {
      return Promise.resolve(data);
    } else {
      return Promise.reject(error);
    }
  } catch (e) {
    console.log('e', e);
    return Promise.reject(e);
  }
}

const deleteAdvertisementRequest = async (input) => {
  console.log('input', input);

  try {
    let { data, error } = await client.mutate({
      mutation: deleteAdvertisementMutation,
      variables: {
        minisiteId: input
      }
    });

    console.log('data', data);

    if (data.deleteAdvertisementById.rows_deleted > 0) {
      return Promise.resolve(input);
    } else {
      return Promise.reject("Device not found");
    }
  } catch (e) {
    console.log('e', e);
    return Promise.reject(e);
  }
}

const createCouponRequest = async (input) => {
  try {
    let { data, error } = await client.mutate({
      mutation: createCouponMutation,
      variables: {
        input: input
      }
    });

    console.log('data', data);
    console.log('error', error);

    if (data) {
      return Promise.resolve(data);
    } else {
      return Promise.reject(error);
    }
  } catch (e) {
    console.log('e', e);
    return Promise.reject(e);
  }
}

const updateCouponRequest = async (input) => {

  console.log('input', input);

  try {
    let { data, error } = await client.mutate({
      mutation: updateCouponMutation,
      variables: {
        input: input
      }
    });

    console.log('data', data);
    console.log('error', error);

    if (data) {
      return Promise.resolve(data);
    } else {
      return Promise.reject(error);
    }
  } catch (e) {
    console.log('e', e);
    return Promise.reject(e);
  }
}

const deleteCouponRequest = async (input) => {
  console.log('input', input);

  try {
    let { data, error } = await client.mutate({
      mutation: deleteCouponMutation,
      variables: {
        minisiteId: input
      }
    });

    console.log('data', data);

    if (data.deleteCouponById.rows_deleted > 0) {
      return Promise.resolve(input);
    } else {
      return Promise.reject("Device not found");
    }
  } catch (e) {
    console.log('e', e);
    return Promise.reject(e);
  }
}

const createVotingRequest = async (input) => {
  try {
    let { data, error } = await client.mutate({
      mutation: createVotingMutation,
      variables: {
        input: input
      }
    });

    console.log('data', data);
    console.log('error', error);

    if (data) {
      return Promise.resolve(data);
    } else {
      return Promise.reject(error);
    }
  } catch (e) {
    console.log('e', e);
    return Promise.reject(e);
  }
}

const updateVotingRequest = async (input) => {

  console.log('input', input);

  try {
    let { data, error } = await client.mutate({
      mutation: updateVotingMutation,
      variables: {
        input: input
      }
    });

    console.log('data', data);
    console.log('error', error);

    if (data) {
      return Promise.resolve(data);
    } else {
      return Promise.reject(error);
    }
  } catch (e) {
    console.log('e', e);
    return Promise.reject(e);
  }
}

const deleteVotingRequest = async (input) => {
  console.log('input', input);

  try {
    let { data, error } = await client.mutate({
      mutation: deleteVotingMutation,
      variables: {
        minisiteId: input
      }
    });

    console.log('data', data);

    if (data.deleteVotingById.rows_deleted > 0) {
      return Promise.resolve(input);
    } else {
      return Promise.reject("Device not found");
    }
  } catch (e) {
    console.log('e', e);
    return Promise.reject(e);
  }
}

const createPollingRequest = async (input) => {
  try {
    let { data, error } = await client.mutate({
      mutation: createPollingMutation,
      variables: {
        input: input
      }
    });

    console.log('data', data);
    console.log('error', error);

    if (data) {
      return Promise.resolve(data);
    } else {
      return Promise.reject(error);
    }
  } catch (e) {
    console.log('e', e);
    return Promise.reject(e);
  }
}

const updatedPollingRequest = async (input) => {

  console.log('input', input);

  try {
    let { data, error } = await client.mutate({
      mutation: updatePollingMutation,
      variables: {
        input: input
      }
    });

    console.log('data', data);
    console.log('error', error);

    if (data) {
      return Promise.resolve(data);
    } else {
      return Promise.reject(error);
    }
  } catch (e) {
    console.log('e', e);
    return Promise.reject(e);
  }
}

const deletePollingRequest = async (input) => {
  console.log('input', input);

  try {
    let { data, error } = await client.mutate({
      mutation: deletePollingMutation,
      variables: {
        minisiteId: input
      }
    });

    console.log('data', data);

    if (data.deletePollingById.rows_deleted > 0) {
      return Promise.resolve(input);
    } else {
      return Promise.reject("Device not found");
    }
  } catch (e) {
    console.log('e', e);
    return Promise.reject(e);
  }
}


const createDeepLinkRequest = async (input) => {
  try {
    let { data, error } = await client.mutate({
      mutation: createDeepLinkMutation,
      variables: {
        input: input
      }
    });

    console.log('data', data);
    console.log('error', error);

    if (data) {
      return Promise.resolve(data);
    } else {
      return Promise.reject(error);
    }
  } catch (e) {
    console.log('e', e);
    return Promise.reject(e);
  }
}

const updatedDeepLinkRequest = async (input) => {

  console.log('input', input);

  try {
    let { data, error } = await client.mutate({
      mutation: updateDeepLinkMutation,
      variables: {
        input: input
      }
    });

    console.log('data', data);
    console.log('error', error);

    if (data) {
      return Promise.resolve(data);
    } else {
      return Promise.reject(error);
    }
  } catch (e) {
    console.log('e', e);
    return Promise.reject(e);
  }
}

const deleteDeepLinkRequest = async (input) => {
  console.log('input', input);

  try {
    let { data, error } = await client.mutate({
      mutation: deleteDeepLinkMutation,
      variables: {
        minisiteId: input
      }
    });

    console.log('data', data);

    if (data.deleteDeepLinkById.rows_deleted > 0) {
      return Promise.resolve(input);
    } else {
      return Promise.reject("Device not found");
    }
  } catch (e) {
    console.log('e', e);
    return Promise.reject(e);
  }
}

function* fetchAdvertisementsCall({payload}) {
  console.log('fetchAdvertisementsCall', payload);
  const {applicationId} = payload;

  try {
    const fetchedAdvertisements = yield call(fetchAdvertisementsRequest, applicationId);
    yield put(fetchAdvertisementsSuccess(applicationId, fetchedAdvertisements));
  } catch (error) {
    yield put(fetchError(error));
  }
}

function* fetchVotingQuestionsCall({payload}) {
  console.log('fetchVotingQuestionsCall', payload);
  const {voting} = payload;

  try {
    const fetched = yield call(fetchVotingQuestionsRequest, voting);
    yield put(fetchVotingQuestionsSuccess(voting, fetched));
  } catch (error) {
    yield put(fetchError(error));
  }
}

function* fetchPollingQuestionsCall({payload}) {
  console.log('fetchPollingQuestionsCall', payload);
  const {polling} = payload;

  try {
    const fetched = yield call(fetchPollingQuestionsRequest, polling);
    yield put(fetchPollingQuestionsSuccess(polling, fetched));
  } catch (error) {
    yield put(fetchError(error));
  }
}

function* fetchVotingAnswersCall({payload}) {
  console.log('fetchVotingAnswersCall', payload);
  const {votingQuestionId} = payload;

  try {
    const fetched = yield call(fetchVotingAnswersRequest, votingQuestionId);
    yield put(fetchVotingAnswersSuccess(votingQuestionId, fetched));
  } catch (error) {
    yield put(fetchError(error));
  }
}

function* fetchPollingAnswersCall({payload}) {
  console.log('fetchPollingAnswersCall', payload);
  const {pollingQuestionId} = payload;

  try {
    const fetched = yield call(fetchPollingAnswersRequest, pollingQuestionId);
    yield put(fetchPollingAnswersSuccess(pollingQuestionId, fetched));
  } catch (error) {
    yield put(fetchError(error));
  }
}

function* fetchCouponsCall({payload}) {
  const {applicationId} = payload;

  try {
    const fetchedCoupons = yield call(fetchCouponsRequest, applicationId);
    yield put(fetchCouponsSuccess(applicationId, fetchedCoupons));
  } catch (error) {
    yield put(fetchError(error));
  }
}

function* fetchVotingsCall({payload}) {
  const {applicationId} = payload;

  try {
    const fetchedVotings = yield call(fetchVotingsRequest, applicationId);
    yield put(fetchVotingsSuccess(applicationId, fetchedVotings));
  } catch (error) {
    yield put(fetchError(error));
  }
}

function* fetchPollingsCall({payload}) {
  const {applicationId} = payload;

  try {
    const fetchedPollings = yield call(fetchPollingsRequest, applicationId);
    yield put(fetchPollingsSuccess(applicationId, fetchedPollings));
  } catch (error) {
    yield put(fetchError(error));
  }
}

function* fetchDeepLinksCall({payload}) {
  const {applicationId} = payload;

  try {
    const fetchedDeepLinks = yield call(fetchDeepLinksRequest, applicationId);
    yield put(fetchDeepLinksSuccess(applicationId, fetchedDeepLinks));
  } catch (error) {
    yield put(fetchError(error));
  }
}

function* fetchAdvertisementCall({payload}) {
  console.log('fetchAdvertisementCall', payload);
  const {minisiteId} = payload;

  try {
    const fetchedAdvertisement = yield call(fetchAdvertisementRequest, minisiteId);
    yield put(fetchAdvertisementSuccess(minisiteId, fetchedAdvertisement));
  } catch (error) {
    yield put(fetchError(error));
  }
}

function* fetchCouponCall({payload}) {
  const {minisiteId} = payload;

  try {
    const fetchedCoupon = yield call(fetchCouponRequest, minisiteId);
    yield put(fetchCouponSuccess(minisiteId, fetchedCoupon));
  } catch (error) {
    yield put(fetchError(error));
  }
}

function* fetchVotingCall({payload}) {
  const {minisiteId} = payload;

  try {
    const fetchedVoting = yield call(fetchVotingRequest, minisiteId);
    yield put(fetchVotingSuccess(minisiteId, fetchedVoting));
  } catch (error) {
    yield put(fetchError(error));
  }
}

function* fetchPollingCall({payload}) {
  const {minisiteId} = payload;

  try {
    const fetchedPolling = yield call(fetchPollingRequest, minisiteId);
    yield put(fetchPollingSuccess(minisiteId, fetchedPolling));
  } catch (error) {
    yield put(fetchError(error));
  }
}

function* fetchDeepLinkCall({payload}) {
  const {minisiteId} = payload;

  try {
    const fetchedDeepLink = yield call(fetchDeepLinkRequest, minisiteId);
    yield put(fetchDeepLinkSuccess(minisiteId, fetchedDeepLink));
  } catch (error) {
    yield put(fetchError(error));
  }
}

function* fetchEventsCall({payload}) {
  console.log('fetchEventsCall', payload);
  const {minisiteId} = payload;

  try {
    const fetchedEvents = yield call(fetchEventsRequest, minisiteId);
    yield put(fetchEventsSuccess(minisiteId, fetchedEvents));
  } catch (error) {
    yield put(fetchError(error));
  }
}

function* createEventCall({payload}) {

  try {
    const createdEvent = yield call(createEventRequest, payload);
    yield put(createEventSuccess(createdEvent));
  } catch (error) {
    console.log('error', error);
    yield put(fetchError(error));
  }
}

function* updateEventCall({payload}) {

  try {
    const updatedEvent = yield call(updateEventRequest, payload);
    yield put(updateEventSuccess(updatedEvent));
  } catch (error) {
    console.log('error', error);
    yield put(fetchError(error));
  }
}

function* deleteEventCall({payload}) {

  try {
    const deletedEvent = yield call(deleteEventRequest, payload);
    yield put(deleteEventSuccess(deletedEvent));
  } catch (error) {
    console.log('error', error);
    yield put(fetchError(error));
  }
}

function* createAdvertisementCall({payload}) {

  try {
    const createdAdvertisement = yield call(createAdvertisementRequest, payload);
    yield put(createAdvertisementSuccess(createdAdvertisement));
  } catch (error) {
    console.log('error', error);
    yield put(fetchError(error));
  }
}

function* updateAdvertisementCall({payload}) {

  try {
    const updatedAdvertisement = yield call(updateAdvertisementRequest, payload);
    yield put(updateAdvertisementSuccess(updatedAdvertisement));
  } catch (error) {
    console.log('error', error);
    yield put(fetchError(error));
  }
}

function* deleteAdvertisementCall({payload}) {

  try {
    const deletedAdvertisement = yield call(deleteAdvertisementRequest, payload);
    yield put(deleteAdvertisementSuccess(deletedAdvertisement));
  } catch (error) {
    console.log('error', error);
    yield put(fetchError(error));
  }
}


function* createCouponCall({payload}) {

  try {
    const createdCoupon = yield call(createCouponRequest, payload);
    yield put(createCouponSuccess(createdCoupon));
  } catch (error) {
    console.log('error', error);
    yield put(fetchError(error));
  }
}

function* updateCouponCall({payload}) {

  try {
    const updatedCoupon = yield call(updateCouponRequest, payload);
    yield put(updateCouponSuccess(updatedCoupon));
  } catch (error) {
    console.log('error', error);
    yield put(fetchError(error));
  }
}

function* deleteCouponCall({payload}) {

  try {
    const deletedCoupon = yield call(deleteCouponRequest, payload);
    yield put(deleteCouponSuccess(deletedCoupon));
  } catch (error) {
    console.log('error', error);
    yield put(fetchError(error));
  }
}

function* createVotingCall({payload}) {

  try {
    const createdVoting = yield call(createVotingRequest, payload);
    yield put(createVotingSuccess(createdVoting));
  } catch (error) {
    console.log('error', error);
    yield put(fetchError(error));
  }
}

function* updateVotingCall({payload}) {

  try {
    const updatedVoting = yield call(updateVotingRequest, payload);
    yield put(updateVotingSuccess(updatedVoting));
  } catch (error) {
    console.log('error', error);
    yield put(fetchError(error));
  }
}

function* deleteVotingCall({payload}) {

  try {
    const deletedVoting = yield call(deleteVotingRequest, payload);
    yield put(deleteVotingSuccess(deletedVoting));
  } catch (error) {
    console.log('error', error);
    yield put(fetchError(error));
  }
}

function* createPollingCall({payload}) {

  try {
    const createdPolling = yield call(createPollingRequest, payload);
    yield put(createPollingSuccess(createdPolling));
  } catch (error) {
    console.log('error', error);
    yield put(fetchError(error));
  }
}

function* updatedPollingCall({payload}) {

  try {
    const updatedPolling = yield call(updatedPollingRequest, payload);
    yield put(updatePollingSuccess(updatedPolling));
  } catch (error) {
    console.log('error', error);
    yield put(fetchError(error));
  }
}

function* deletePollingCall({payload}) {

  try {
    const deletedPolling = yield call(deletePollingRequest, payload);
    yield put(deletePollingSuccess(deletedPolling));
  } catch (error) {
    console.log('error', error);
    yield put(fetchError(error));
  }
}

function* createDeepLinkCall({payload}) {

  try {
    const createdDeepLink = yield call(createDeepLinkRequest, payload);
    yield put(createDeepLinkSuccess(createdDeepLink));
  } catch (error) {
    console.log('error', error);
    yield put(fetchError(error));
  }
}

function* updatedDeepLinkCall({payload}) {

  try {
    const updatedDeepLink = yield call(updatedDeepLinkRequest, payload);
    yield put(updateDeepLinkSuccess(updatedDeepLink));
  } catch (error) {
    console.log('error', error);
    yield put(fetchError(error));
  }
}

function* deleteDeepLinkCall({payload}) {

  try {
    const deletedDeepLink = yield call(deleteDeepLinkRequest, payload);
    yield put(deleteDeepLinkSuccess(deletedDeepLink));
  } catch (error) {
    console.log('error', error);
    yield put(fetchError(error));
  }
}

export function* fetchAdvertisements() {
  console.log('fetchAdvertisements');
  yield takeEvery(FETCHADVERTISEMENTS, fetchAdvertisementsCall);
}

export function* fetchCoupons() {
  yield takeEvery(FETCHCOUPONS, fetchCouponsCall);
}

export function* fetchVotings() {
  yield takeEvery(FETCHVOTINGS, fetchVotingsCall);
}

export function* fetchDeepLinks() {
  yield takeEvery(FETCHDEEPLINKS, fetchDeepLinksCall);
}

export function* fetchPollings() {
  yield takeEvery(FETCHPOLLINGS, fetchPollingsCall);
}

export function* fetchAdvertisement() {
  console.log('fetchAdvertisement');
  yield takeEvery(FETCHADVERTISEMENT, fetchAdvertisementCall);
}

export function* fetchCoupon() {
  yield takeEvery(FETCHCOUPON, fetchCouponCall);
}

export function* fetchVoting() {
  yield takeEvery(FETCHVOTING, fetchVotingCall);
}

export function* fetchPolling() {
  yield takeEvery(FETCHPOLLING, fetchPollingCall);
}

export function* fetchDeepLink() {
  yield takeEvery(FETCHDEEPLINK, fetchDeepLinkCall);
}

export function* fetchEvents() {
  console.log('fetchEvents');
  yield takeEvery(FETCHEVENTS, fetchEventsCall);
}

export function* createEvent() {
  yield takeEvery(CREATEEVENT, createEventCall);
}

export function* updateEvent() {
  yield takeEvery(UPDATEEVENT, updateEventCall);
}

export function* deleteEvent() {
  yield takeEvery(DELETEEVENT, deleteEventCall);
}

export function* fetchVotingQuestions() {
  yield takeEvery(FETCHVOTINGQUESTIONS, fetchVotingQuestionsCall);
}

export function* fetchPollingQuestions() {
  yield takeEvery(FETCHPOLLINGQUESTIONS, fetchPollingQuestionsCall);
}

export function* fetchVotingAnswers() {
  yield takeEvery(FETCHVOTINGANSWERS, fetchVotingAnswersCall);
}

export function* fetchPollingAnswers() {
  yield takeEvery(FETCHPOLLINGANSWERS, fetchPollingAnswersCall);
}

export function* createAdvertisement() {
  yield takeEvery(CREATEADVERTISEMENT, createAdvertisementCall);
}

export function* updateAdvertisement() {
  yield takeEvery(UPDATEADVERTISEMENT, updateAdvertisementCall);
}

export function* deleteAdvertisement() {
  yield takeEvery(DELETEADVERTISEMENT, deleteAdvertisementCall);
}

export function* createCoupon() {
  yield takeEvery(CREATECOUPON, createCouponCall);
}

export function* updateCoupon() {
  yield takeEvery(UPDATECOUPON, updateCouponCall);
}

export function* deleteCoupon() {
  yield takeEvery(DELETECOUPON, deleteCouponCall);
}

export function* createVoting() {
  yield takeEvery(CREATEVOTING, createVotingCall);
}

export function* updateVoting() {
  yield takeEvery(UPDATEVOTING, updateVotingCall);
}

export function* deleteVoting() {
  yield takeEvery(DELETEVOTING, deleteVotingCall);
}

export function* createdPolling() {
  yield takeEvery(CREATEPOLLING, createPollingCall);
}

export function* updatedPolling() {
  yield takeEvery(UPDATEPOLLING, updatedPollingCall);
}

export function* deletedPolling() {
  yield takeEvery(DELETEPOLLING, deletePollingCall);
}

export function* createdDeepLink() {
  yield takeEvery(CREATEDEEPLINK, createDeepLinkCall);
}

export function* updatedDeepLink() {
  yield takeEvery(UPDATEDEEPLINK, updatedDeepLinkCall);
}

export function* deletedDeepLink() {
  yield takeEvery(DELETEDEEPLINK, deleteDeepLinkCall);
}


export default function* rootSaga() {
  yield all([fork(fetchAdvertisements),
    fork(fetchCoupons),
    fork(fetchVotings),
    fork(fetchPollings),
    fork(fetchDeepLinks),
    fork(fetchAdvertisement),
    fork(fetchCoupon),
    fork(fetchVoting),
    fork(fetchPolling),
    fork(fetchDeepLink),
    fork(fetchEvents),
    fork(createEvent),
    fork(updateEvent),
    fork(deleteEvent),
    fork(fetchVotingQuestions),
    fork(fetchPollingQuestions),
    fork(fetchVotingAnswers),
    fork(fetchPollingAnswers),
    fork(createAdvertisement),
    fork(updateAdvertisement),
    fork(deleteAdvertisement),
    fork(createCoupon),
    fork(updateCoupon),
    fork(deleteCoupon),
    fork(createVoting),
    fork(updateVoting),
    fork(deleteVoting),
    fork(createdPolling),
    fork(updatedPolling),
    fork(deletedPolling),
    fork(createdDeepLink),
    fork(updatedDeepLink),
    fork(deletedDeepLink)]);
}
